import React, { useState, useRef, useEffect, useMemo } from "react";
import viewBless from "../../assets/bless-your-self.png";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  ButtonGroup,
  CircularProgress,
  Dialog,
  Divider,
  Grid,
  IconButton,
  Stack,
} from "@mui/material";
import { useDispatch } from "react-redux";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import TitleTypography from "../../components/typography/TitleTypography";
import ParagraphTypography from "../../components/typography/ParagraphTypography";
import SubtitleTypographyPrimary from "../../components/typography/SubtitleTypographyPrimary";

import { Remove as RemoveIcon } from "@mui/icons-material";
import { AddIcon } from "@chakra-ui/icons";
import { Close as CloseIcon } from "@mui/icons-material";
import SubtitleTypography from "../../components/typography/SubtitleTypography";
import "./Chadhava.scss";
import { DateCalendar, LocalizationProvider } from "@mui/x-date-pickers";
import RoundedButton from "../../components/button/RoundedButton";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import AlertDialog from "../../components/dialog/AlertDialog";
import {
  formatNumberWithK,
  getCityStateFromTemple,
  getImageListFromTemple,
  truncateToTwoDecimals,
} from "../../utils/HelperFunctions";
import { LOCALIZATION } from "../../utils/localization";
import { useTranslation } from "react-i18next";
import { ExpandMore as ExpandMoreIcon } from "@mui/icons-material";
import {
  CAROUSEL_REMOVE_ARRAOW_ON_DEVICE,
  chadhavaSubscriptionSections,
  DEVOTEE_EXPERIENCE_CAROUSEL,
  LOCALSTORAGE_KEY,
  orderType,
  PUJALOADIMG,
} from "../../utils/Constants";
import ServiceInfo from "../../components/ServiceInfoDetailsTop/ServiceInfo";
import { getTopFivePujaFeedBack } from "../../store/actions/pujaAction";
import Carousel from "react-multi-carousel";

import { chadhavaSections } from "../../utils/Constants";
import BannerCarouselWithVideo from "../../components/ServiceInfoDetailsTop/BannerCarouselWithVideo";
import ImageView from "../../components/ImageView/ImageView";
import OfferPriceTypography from "../../components/typography/OfferPriceTypography";
import TrustedLogo from "../../components/trustedLogo/TrustedLogo";
import DashboardFeedback from "../../components/card/DashboardFeedback/DashboardFeedback";
import ShowMoreShowLess from "../../components/ShowMoreShowLess/ShowMoreShowLess";
import VideoCard from "../../components/card/videoCard/VideoCard";
import ChadhavaSubscription from "../../components/chadhavaSubscription/ChadhavaSubscription";
import dayjs from "dayjs";
import CustomDay from "../../components/customDay/CustomDay";
import SubscriptionSwitch from "../../components/subscriptionSwitch/SubscriptionSwitch";
import { getFirstAvailableBookingDate } from "../../utils/dateUtilFunctions";
import Infographics from "../../components/Infographics/Infographics";
import { ChadhavainfographicDesktop, ChadhavainfographicMobile } from "../../utils/imageConstants";
import SubSectionNav from "../../components/subNavigation/SubSectionNav";
import useStickySwitcher from "../../hooks/useStickySwitcher";

const ChadhavaDetailsView: React.FC<any> = (props) => {
  const { t } = useTranslation();
  const {
    pujaDetails,
    templeProfilePic,
    templeDetails,
    templePersonalInfo,
    handleIncrement,
    handleDecrement,
    filteredChadhavaList,
    navigateToSeeVideoView,
    getAvilableChadhavaDate,
    totalPrice,
    totalPriceDisplay,
    setIsDateTimePicker,
    isDateTimePicker,
    shouldDisableDate,
    setPujaDateAndTime,
    pujaDateAndTime,
    setPopupItemAlreadyAddedInCart,
    preprocessingAndProceedToAddmemberScreen,
    popupItemAlreadyAddedInCart,
    currencySymbols,
    isCountryDisabledForBooking,
    isLoading,
    defaultCalendardate,
    itemAddLimitPopUp,
    setItemAddLimitPopUp,
    offerActualPriceLocal,
    isOverseas,
    overSeasRate,
    chadhavaVideos,
    isSingleDatePujaEnabled,
    isSubscriptionAvailable,
    showSubscription,
    handleClickSubscriptionButton,
    subscriptionChadhavaList,
    handleToggleSubscriptionChadhava,
    chadhavaSubscriptions,
    subscriptionAddOn,
    handleAddFromAddOn,
    selectedChadhavaSubscriptionPlan,
    onSelectSubscriptionPlan,
    totalSubscriptionPrice,
    setDefaultCalendardate,
    localRestrictionChadavaDate,
  } = props;

  const [expanded, setExpanded] = useState<string | false>("panel1");
  const [isExpandedTempleDetails, setIsExpandedTempleDetails] = useState<any>(
    []
  );
  const [wordLimit, setWordLimit] = useState(window.innerWidth < 600 ? 10 : 25);

  const [activeVideoUrl, setActiveVideoUrl] = useState<number | null>(null);
  const [activeVideoId, setActiveVideoId] = useState<number | null>(null);

  const toggleReadMore = (id: number) => {
    let tempArr = [...isExpandedTempleDetails];
    if (isExpandedTempleDetails.includes(id)) {
      tempArr = tempArr.filter((item: any) => item !== id);
    } else {
      tempArr.push(id);
    }
    setIsExpandedTempleDetails([...tempArr]);
  };
  useEffect(() => {
    const handleResize = () => {
      setWordLimit(window.innerWidth < 450 ? 12 : 20);
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);


  const dispatch: any = useDispatch();
  const [userReview, setUserReview] = useState<any>([]);

  const [isActiveTemple, setisActiveTemple] = useState<any>(false);
  // Chadhava Add Popup
  const [isPopupOpen, setPopupOpen] = useState(false);
  const popupRef = useRef<HTMLDivElement | null>(null);
  const [
    openAlertDialogForBookingNotAllowed,
    setOpenAlertDialogForBookingNotAllowed,
  ] = useState<any>(false);

  // CUSTOM HOOKs
  const isAboveFooter = useStickySwitcher(".footerArea", "50px");

  const handleClickOutside = (event: MouseEvent) => {
    if (popupRef.current && !popupRef.current.contains(event.target as Node)) {
      setPopupOpen(false);
    }
  };

  const savedLanguage =
    localStorage.getItem(LOCALSTORAGE_KEY.LANG_CODE) ?? "en";

  useEffect(() => {
    if (isPopupOpen) {
      document.addEventListener("mousedown", handleClickOutside);
    } else {
      document.removeEventListener("mousedown", handleClickOutside);
    }
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isPopupOpen]);

  const [urlToShare, setUrlToShare] = useState<string>("");
  useEffect(() => {
    const hostname =
      window.location.hostname === "localhost"
        ? "http://localhost:3000"
        : "https://" + window.location.hostname;
    setUrlToShare(
      `${hostname}/pagelink?chadhavaOftemple=${templeDetails?.nameKey}`
    );
  }, [templeDetails]);

  const [templeName, setTempleName] = useState<string>("");
  const [templeDescriptions, setTempleDescriptions] = useState<string>("");
  const [chadhavaBenefits, setChadhavaBenefits] = useState<any>([]);

  const getActiveSubscriptionSections = () => {
    return chadhavaSubscriptionSections?.filter((section: any) => {
      if (section?.id === "subscription_Add_ons") {
        return (
          Array?.isArray(subscriptionAddOn) && subscriptionAddOn?.length > 0
        );
      }
      if (section?.id === "select_your_Chadhava_plan") {
        return (
          Array?.isArray(chadhavaSubscriptions) &&
          chadhavaSubscriptions?.length > 0
        );
      }
      return true;
    });
  };

  const subHeader = useMemo(() => {
    let header = [...chadhavaSections];
    if (showSubscription) {
      header = header.filter((item: any) => item.id !== "chadhava-items");
      header = [...getActiveSubscriptionSections(), ...header];
    }
    const hasPujaPreviewVideos =
      Array.isArray(chadhavaVideos) && chadhavaVideos.length > 0;
    if (!hasPujaPreviewVideos) {
      header = header.filter((item) => item.id !== "puja-video-preview");
    }
    return header;
  }, [
    showSubscription,
    subscriptionAddOn,
    chadhavaSubscriptions,
    chadhavaVideos,
    templeDetails?.id,
  ]);

  useEffect(() => {
    const firstDate = getFirstAvailableBookingDate(localRestrictionChadavaDate);
    if (firstDate) {
      setPujaDateAndTime((prev: any) => ({
        ...prev,
        pujaDate: dayjs(firstDate),
      }));
      setDefaultCalendardate(firstDate);
    }
  }, [localRestrictionChadavaDate]);

  useEffect(() => {
    if (templePersonalInfo?.name) {
      setTempleName(templePersonalInfo?.name);
    }
    if (templePersonalInfo?.descriptions) {
      setTempleDescriptions(templePersonalInfo?.descriptions);
    }
  }, [templePersonalInfo]);

  useEffect(() => {
    if (templeDetails?.chadhavaBenefits) {
      setChadhavaBenefits(templeDetails?.chadhavaBenefits);
    }
  }, [templeDetails]);

  useEffect(() => {
    if (templeDetails?.nameKey) {
      dispatch(
        getTopFivePujaFeedBack(orderType?.chadhava, templeDetails?.nameKey)
      )
        .then((res: any) => {
          if (res) {
            setUserReview(res);
          }
        })
        .catch((err: any) => {
          console.log(err);
        });
    }
  }, [templeDetails?.nameKey]);

  const templeAddress = getCityStateFromTemple(templePersonalInfo);

  const increment = (item: any) => {
    handleIncrement(item);
  };

  const decrement = (item: any) => {
    handleDecrement(item);
  };

  const addChadhavaItem = (item: any) => {
    if (isCountryDisabledForBooking) {
      setOpenAlertDialogForBookingNotAllowed(true);
    } else {
      props.addChadhavaItem(item);
    }
  };

  let filteredArray = filteredChadhavaList || [];


  const handleCloseAlertDialogForBookingNotAllowed = () => {
    setOpenAlertDialogForBookingNotAllowed(false);
  };

  const handleSetIsDateTimePicker = (isOpen: boolean) => {
    if (isCountryDisabledForBooking) {
      setOpenAlertDialogForBookingNotAllowed(true);
    } else {
      setIsDateTimePicker(isOpen);
    }
  };

  useEffect(() => {
    let _isActiveTemple = false;
    if (templeDetails) {
      _isActiveTemple =
        templeDetails?.isChadhavaEnabled === false ||
        templeDetails?.isClosed === true
          ? false
          : true;
    }
    setisActiveTemple(_isActiveTemple);
  }, [templeDetails]);

  useEffect(() => {
    if (
      !Array.isArray(filteredChadhavaList) ||
      filteredChadhavaList?.length === 0
    )
      return;
    if (filteredChadhavaList?.length !== 1) return;

    const singleItem = filteredChadhavaList[0];
    if (singleItem?.disabled) return;
    const itemWithCount = {
      ...singleItem,
      count: singleItem?.count && singleItem?.count > 0 ? singleItem?.count : 1,
    };
    addChadhavaItem(itemWithCount);
  }, [filteredChadhavaList?.length]);

  const handleChange1 =
    (panel: string) => (event: React.SyntheticEvent, isExpanded: boolean) => {
      setExpanded(isExpanded ? panel : false);
    };

  const chadhavaImages =
    getImageListFromTemple(templePersonalInfo, "chadavaPictures") ?? [];

  const formattedChadhavaImages = chadhavaImages.map((item: any) => {
    if (item?.pictureUrl) {
      return { pictureUrl: item.pictureUrl };
    } else if (item?.videoUrl) {
      return { videoUrl: item.videoUrl };
    } else {
      return { pictureUrl: PUJALOADIMG };
    }
  });

  // For Component Purpose
  const bookedCountChadhava = formatNumberWithK(
    filteredArray && filteredArray.length > 0
      ? filteredArray.length * 1000
      : 13 * 1000
  );
  const chadhavaBookedText = t(
    LOCALIZATION.devotees_booked_Chadhava_from_this_temple
  );

  const isReviewSingle = userReview?.length === 1 ? true : false;
  const isDoubleVideoItem = chadhavaVideos?.length <= 2;

  const bookedSingleDatePuja = () => {
    if (isCountryDisabledForBooking) {
      setOpenAlertDialogForBookingNotAllowed(true);
      return;
    }
    preprocessingAndProceedToAddmemberScreen();
  };
  const handleAfterChange = (currentIndex: number) => {
    setActiveVideoUrl(currentIndex);
  };
  const handleAfterChangeReview = (currentReviewIndex: number) => {
    setActiveVideoId(currentReviewIndex);
  };

  const getDisplayTotalPrice = () => {
    if (isSubscriptionAvailable && showSubscription) {
      const tempTotalSelectedChadhavaPrice = totalPrice * overSeasRate;
      return truncateToTwoDecimals(tempTotalSelectedChadhavaPrice);
    } else {
      return totalPriceDisplay ? totalPriceDisplay : totalPrice;
    }
  };

  const getDisplayTotalOfferPrice = () => {
    if (isSubscriptionAvailable && showSubscription) {
      return truncateToTwoDecimals(offerActualPriceLocal);
    } else {
      return truncateToTwoDecimals(offerActualPriceLocal * overSeasRate);
    }
  };

  return (
    <Box className="pageContainer pujaPage">
      <Box className="pujaBlock">
        <Grid container spacing={1}>
          <Grid
            item
            xs={12}
            md={2}
            lg={2}
            xl={2}
            className="pagehdLeftBlock"
          ></Grid>
          <Grid item xs={12} md={8} lg={8} xl={8}>
            <Box className="pujainfoCenterBlock">
              <Box className="pujaCard" data-scroll-id={"Chadhava-details-service-info"}>
                <Grid
                  className="pujaCardBlock"
                  container
                  spacing={{ xs: 0, sm: 0, lg: 2 }}
                >
                  <Grid item xs={12} sm={12} md={12} lg={6}>
                    <BannerCarouselWithVideo
                      imageArray={formattedChadhavaImages}
                    />
                  </Grid>
                  <Grid item xs={12} sm={12} md={12} lg={6}>
                    <ServiceInfo
                      templeName={templeName}
                      templeAddress={templeAddress}
                      bookedCount={bookedCountChadhava}
                      bookedText={chadhavaBookedText}
                      itemOrderType={orderType?.chadhava}
                      urlToShare={urlToShare}
                      chadhavaDescription={templeDetails?.chadhavaDescription}
                      chadhaveTithiName={templeDetails?.chadhaveTithiName}
                      chadhavaTitle={templeDetails?.chadhavaTitle}
                    />
                  </Grid>
                </Grid>
              </Box>
              {/* SUB HEADER NAVIGATION */}
              <SubSectionNav sections={subHeader} />
              {isSubscriptionAvailable && (
                <Box className="chadhavaSubscriptionAreaSwitch" data-scroll-id={"chadhava-subscription-switch"}>
                  <SubscriptionSwitch
                    buttonTextLeft={t(LOCALIZATION?.Single_Time_Chadhava)}
                    buttonTextRight={t(LOCALIZATION?.Chadhava_Subscription)}
                    badgeText={t(LOCALIZATION?.Save_More)}
                    showSubscription={showSubscription}
                    onToggle={handleClickSubscriptionButton}
                  />

                  {/* Chadhava Subscription Field */}
                  {isSubscriptionAvailable && showSubscription && (
                    <Box className="animate-enter" key="subscription-view" data-scroll-id={"Chadhava-subscription-List"}>
                      <ChadhavaSubscription
                        subscriptionChadhavaList={subscriptionChadhavaList}
                        onClickChadhavaItem={handleToggleSubscriptionChadhava}
                        chadhavaSubscriptions={chadhavaSubscriptions}
                        subscriptionAddOn={subscriptionAddOn}
                        handleAddFromAddOn={handleAddFromAddOn}
                        selectedChadhavaSubscriptionPlan={
                          selectedChadhavaSubscriptionPlan
                        }
                        onSelectSubscriptionPlan={onSelectSubscriptionPlan}
                        totalSubscriptionPrice={totalSubscriptionPrice}
                        templeName={templeName}
                      />
                    </Box>
                  )}
                </Box>
              )}

              {!showSubscription && (
                <Box
                  id="chadhava-items"
                  className="animate-enter"
                  key="items-view"
                >
                  <Box className="chadhavaItemTitle" mb={2} mt={2}>
                    <SubtitleTypographyPrimary
                      title={t(LOCALIZATION.Chadhava_Items)}
                    ></SubtitleTypographyPrimary>
                  </Box>
                  {isLoading === false &&
                    filteredArray?.map((item: any, index: number) => (
                      <Box
                        className={`chadhavaDetailsBlock chadhavaItems ${
                          item?.disabled === true || isActiveTemple === false
                            ? "boxDisable"
                            : ""
                        }`}
                        key={"ChadhavaItem" + index}
                        data-scroll-id={"chadhava-Item-section"}
                      >
                        <Box className="chadhavaItem">
                          <Box className="chadhavaLeft">
                            <Box className="mostOfferTag">
                              {item?.isMostOfferedTag && (
                                <span className="offerItem">
                                  {" "}
                                  {t(LOCALIZATION.Most_offered)}{" "}
                                </span>
                              )}
                            </Box>
                            <Typography sx={{ fontWeight: 500 }}>
                              <span className="itemNameInfo">{item?.name}</span>
                            </Typography>

                            {/* <Typography>
                            {getAvilableChadhavaDate()}
                            {formatRestrictionDates(item.restrictionChadavaDate)?.toString()}
                            {getDayNameFromShortName(
                              item.restrictionChadavaDate
                            )}
                          </Typography> */}

                            {/* {item?.disabled === true && (
                            <Typography sx={{ color: "red" }}>
                            
                              {formatRestrictionDates(item.restrictionChadavaDate)?.toString()}
                              {getDayNameFromShortName(formatRestrictionDates(item.restrictionChadavaDate))}
                            </Typography>
                          )} */}

                            <ParagraphTypography
                              title={
                                <ShowMoreShowLess
                                  text={item?.itemDescription || ""}
                                  mode="line"
                                  lines={2}
                                  // limit={300} ->
                                />
                              }
                            />

                            <Box className="priceInfoSection">
                              <Box component="span" className="mainPrice">
                                <TitleTypography
                                  title={`${currencySymbols}${
                                    item?.priceInfo?.finalPriceOv
                                      ? item?.priceInfo?.finalPriceOv
                                      : item?.priceInfo?.finalPrice
                                  } ${item?.count ? `x ${item?.count}` : ""}`}
                                />
                              </Box>
                              {/* strikethrough price */}
                              {(item?.priceInfo?.offerActualPrice > 0 ||
                                item?.priceInfo?.offerActualPriceOv > 0) && (
                                <Typography
                                  variant="body2"
                                  className="cuttedPrice"
                                >
                                  {currencySymbols ?? "₹"}
                                  {isOverseas
                                    ? truncateToTwoDecimals(
                                        (item?.priceInfo?.offerActualPriceOv
                                          ? item?.priceInfo?.offerActualPriceOv
                                          : item?.priceInfo?.offerActualPrice) *
                                          (item?.count || 1) *
                                          overSeasRate,
                                      )
                                    : item?.priceInfo?.offerActualPriceOv
                                      ? item?.priceInfo?.offerActualPriceOv
                                      : item?.priceInfo?.offerActualPrice}
                                </Typography>
                              )}
                            </Box>
                            {/* <CalculateOverSeasPrice  inrPrice={item?.priceInfo?.finalPrice} priceFor="chadhava"/> */}
                          </Box>
                          <Box className="chadhavaRight">
                            <Box className="itemImg">
                              <ImageView src={item?.image} alt="Item image" />
                            </Box>
                            {item?.count === 0 ? (
                              <Box className="btnAdd">
                                <Button
                                  className="chadhavaAdd"
                                  variant="outlined"
                                  onClick={(e) => {
                                    e.preventDefault();
                                    addChadhavaItem(item);
                                  }}
                                >
                                  {t(LOCALIZATION.ADD)}
                                </Button>
                              </Box>
                            ) : (
                              <Box className="addItemsBtns">
                                <ButtonGroup className="btnsGroup">
                                  <Button
                                    variant="contained"
                                    onClick={(e) => {
                                      e.preventDefault();
                                      decrement(item);
                                    }}
                                  >
                                    <RemoveIcon fontSize="small" />
                                  </Button>
                                  <Button variant="contained">
                                    {item?.count}
                                  </Button>
                                  <Button
                                    variant="contained"
                                    onClick={() => increment(item)}
                                  >
                                    <AddIcon fontSize="small" />
                                  </Button>
                                </ButtonGroup>
                              </Box>
                            )}
                          </Box>
                        </Box>
                      </Box>
                    ))}
                  {isLoading === true && (
                    <Box className="loadingCircle">
                      <CircularProgress color="primary" />
                    </Box>
                  )}
                </Box>
              )}

              <Box
                className="overViewText"
                sx={{ whiteSpace: "pre-line" }}
                id="temple-details"
              >
                <Box sx={{ paddingBottom: "8px" }}>
                  <SubtitleTypographyPrimary
                    title={t(LOCALIZATION.Temple_Details)}
                    data-scroll-id={"chadhavaSection-temple-details"}
                  />
                </Box>
                <ParagraphTypography
                  title={
                    <ShowMoreShowLess
                      text={templeDescriptions || ""}
                      mode="line"
                      lines={2}
                      // limit={300}
                    />
                  }
                />
              </Box>

              <Box className="pujaBenefits" id="benefit-chadhava" data-scroll-id={"benefit-of-the-chadhava"}>
                <SubtitleTypographyPrimary
                  title={t(LOCALIZATION.Benefits_of_this_Chadhava)}
                ></SubtitleTypographyPrimary>
                {chadhavaBenefits.map((item: any) => {
                  return (
                    <Box className="benefitsCard" key={item?.benefitId}>
                      <SubtitleTypography
                        title={`${item.name}`}
                      ></SubtitleTypography>
                      <Box className="benefitCardImg">
                        <ImageView src={`${item.url}`} alt="Benefit Image" />
                      </Box>
                      {item.description && (
                        <ParagraphTypography
                          title={`${item.description}`}
                        ></ParagraphTypography>
                      )}
                    </Box>
                  );
                })}
              </Box>

              <Box className="pujaProccessSteps" id="chadhava-steps" data-scroll-id={"Chadhava-infographics"}>
                <Infographics
                  infographicDesktop={ChadhavainfographicDesktop}
                  infographicMobile={ChadhavainfographicMobile}
                />
              </Box>

              {/* Devotee Experience */}
              {userReview?.length ? (
                <Box
                  className="testimonial carouselArrowColor"
                  id="devotee-experience"
                  data-scroll-id={"chadhavaDetails-devotee-experience"}
                >
                  <SubtitleTypographyPrimary
                    title={t(LOCALIZATION.Devotee_Experience)}
                  ></SubtitleTypographyPrimary>
                  <Box mt={2}>
                    <Carousel
                      responsive={DEVOTEE_EXPERIENCE_CAROUSEL}
                      swipeable={true}
                      draggable={true}
                      showDots={true}
                      keyBoardControl={true}
                      removeArrowOnDeviceType={CAROUSEL_REMOVE_ARRAOW_ON_DEVICE}
                      className={`testimonialCarousel ${
                        isReviewSingle ? "singleItem" : ""
                      }`}
                      afterChange={handleAfterChangeReview}
                      pauseOnHover={false}
                    >
                      {userReview?.length > 0 &&
                        userReview?.map((_item: any) => (
                          <DashboardFeedback
                            key={_item?.id}
                            feedbackData={_item}
                            pujaDetails={pujaDetails}
                            selectedTempleDetails={templeDetails}
                            className="compactFeedbackCard"
                            activeVideoId={activeVideoId}
                            setActiveVideoId={setActiveVideoId}
                          />
                        ))}
                    </Carousel>
                  </Box>
                </Box>
              ) : null}

              {chadhavaVideos && (
                <Box
                  className="pujaVideoPreview carouselArrowColor"
                  id="puja-video-preview"
                  data-scroll-id={"the-temple-dekho-promise"}
                >
                  <SubtitleTypographyPrimary
                    title={t(LOCALIZATION.The_Temple_Dekho_Promise)}
                  />
                  <Typography variant="body1" mt={1}>
                    {t(LOCALIZATION.Promise_Video_Description)}
                  </Typography>

                  <Box mt={3}>
                    {Array.isArray(chadhavaVideos) &&
                      chadhavaVideos.length > 0 && (
                        <Carousel
                          responsive={DEVOTEE_EXPERIENCE_CAROUSEL}
                          swipeable
                          draggable
                          showDots
                          keyBoardControl
                          autoPlaySpeed={4000}
                          infinite
                          removeArrowOnDeviceType={
                            CAROUSEL_REMOVE_ARRAOW_ON_DEVICE
                          }
                          className={`pujaVideoCarousel ${
                            isDoubleVideoItem ? "singleItem" : ""
                          }`}
                          afterChange={handleAfterChange}
                          pauseOnHover={false}
                        >
                          {chadhavaVideos.map((video: any, index: number) => (
                            <VideoCard
                              key={video?.videoUrl}
                              videoUrl={video?.videoUrl}
                              showVideoDescription={
                                video?.showVideoDescription ?? ""
                              }
                              isPlaying={activeVideoUrl === index}
                              onClickPlay={(isPlay: boolean) => {
                                if (isPlay) {
                                  setActiveVideoUrl(index);
                                } else {
                                  setActiveVideoUrl(null);
                                }
                              }}
                            />
                          ))}
                        </Carousel>
                      )}
                  </Box>
                </Box>
              )}

              <Box className="chadhavaFaq" id="faq" data-scroll-id={"faq-section-for-chadhava"}>
                <SubtitleTypographyPrimary
                  title={t(LOCALIZATION.Frequently_Asked_Questions)}
                ></SubtitleTypographyPrimary>

                <Box className="chadhavaFaqList">
                  <Accordion
                    className="accordionInfo"
                    expanded={expanded === "panel1"}
                    onChange={handleChange1("panel1")}
                    sx={{
                      "&.Mui-expanded::before": {
                        opacity: 1,
                      },
                    }}
                  >
                    <AccordionSummary
                      expandIcon={
                        <ExpandMoreIcon
                          sx={{
                            color: expanded === "panel1" ? "#d56939" : "#000",
                            transform:
                              expanded === "panel1"
                                ? "rotate(180deg)"
                                : "rotate(270deg)",
                            transition: "transform 0.3s ease",
                          }}
                        />
                      }
                      aria-controls="panel1-content"
                      id="panel1-header"
                      sx={{
                        p: 0,
                        fontWeight: "600",
                      }}
                    >
                      {t(
                        LOCALIZATION.Why_should_I_choose_Temple_Dekho_for_temple_Chadhava,
                      )}
                    </AccordionSummary>
                    <AccordionDetails sx={{ p: 0, lineHeight: "1.5" }}>
                      {t(
                        LOCALIZATION.Why_should_I_choose_Temple_Dekho_for_temple_ChadhavaAnswer,
                      )}
                    </AccordionDetails>
                  </Accordion>

                  <Accordion
                    className="accordionInfo"
                    expanded={expanded === "panel2"}
                    onChange={handleChange1("panel2")}
                    sx={{
                      "&.Mui-expanded::before": {
                        opacity: 1,
                      },
                    }}
                  >
                    <AccordionSummary
                      expandIcon={
                        <ExpandMoreIcon
                          sx={{
                            color: expanded === "panel2" ? "#d56939" : "#000",
                            transform:
                              expanded === "panel2"
                                ? "rotate(180deg)"
                                : "rotate(270deg)",
                            transition: "transform 0.3s ease",
                          }}
                        />
                      }
                      aria-controls="panel2-content"
                      id="panel2-header"
                      sx={{
                        p: 0,
                        fontWeight: "600",
                      }}
                    >
                      {t(LOCALIZATION.What_is_Chadhava)}
                    </AccordionSummary>
                    <AccordionDetails sx={{ p: 0, lineHeight: "1.5" }}>
                      {t(LOCALIZATION.What_is_ChadhavaAnswer)}
                    </AccordionDetails>
                  </Accordion>

                  <Accordion
                    className="accordionInfo"
                    expanded={expanded === "panel3"}
                    onChange={handleChange1("panel3")}
                    sx={{
                      "&.Mui-expanded::before": {
                        opacity: 1,
                      },
                    }}
                  >
                    <AccordionSummary
                      expandIcon={
                        <ExpandMoreIcon
                          sx={{
                            color: expanded === "panel3" ? "#d56939" : "#000",
                            transform:
                              expanded === "panel3"
                                ? "rotate(180deg)"
                                : "rotate(270deg)",
                            transition: "transform 0.3s ease",
                          }}
                        />
                      }
                      aria-controls="panel3-content"
                      id="panel3-header"
                      sx={{
                        p: 0,
                        fontWeight: "600",
                      }}
                    >
                      {t(LOCALIZATION.Who_designated_to_offer_the_Chadhava)}
                    </AccordionSummary>
                    <AccordionDetails sx={{ p: 0, lineHeight: "1.5" }}>
                      {t(
                        LOCALIZATION.Who_designated_to_offer_the_ChadhavaAnswer,
                      )}
                    </AccordionDetails>
                  </Accordion>

                  <Accordion
                    className="accordionInfo"
                    expanded={expanded === "panel4"}
                    onChange={handleChange1("panel4")}
                    sx={{
                      "&.Mui-expanded::before": {
                        opacity: 1,
                      },
                    }}
                  >
                    <AccordionSummary
                      expandIcon={
                        <ExpandMoreIcon
                          sx={{
                            color: expanded === "panel4" ? "#d56939" : "#000",
                            transform:
                              expanded === "panel4"
                                ? "rotate(180deg)"
                                : "rotate(270deg)",
                            transition: "transform 0.3s ease",
                          }}
                        />
                      }
                      aria-controls="panel4-content"
                      id="panel4-header"
                      sx={{
                        p: 0,
                        fontWeight: "600",
                      }}
                    >
                      {t(LOCALIZATION.What_are_the_benefits_of_Chadhava)}
                    </AccordionSummary>
                    <AccordionDetails sx={{ p: 0, lineHeight: "1.5" }}>
                      {t(LOCALIZATION.What_are_the_benefits_of_ChadhavaAnswer)}
                    </AccordionDetails>
                  </Accordion>

                  <Accordion
                    className="accordionInfo"
                    expanded={expanded === "panel5"}
                    onChange={handleChange1("panel5")}
                    sx={{
                      "&.Mui-expanded::before": {
                        opacity: 1,
                      },
                    }}
                  >
                    <AccordionSummary
                      expandIcon={
                        <ExpandMoreIcon
                          sx={{
                            color: expanded === "panel5" ? "#d56939" : "#000",
                            transform:
                              expanded === "panel5"
                                ? "rotate(180deg)"
                                : "rotate(270deg)",
                            transition: "transform 0.3s ease",
                          }}
                        />
                      }
                      aria-controls="panel5-content"
                      id="panel5-header"
                      sx={{
                        p: 0,
                        fontWeight: "600",
                      }}
                    >
                      {t(
                        LOCALIZATION.I_dont_know_my_Gotram_can_I_offer_Chadhava,
                      )}
                    </AccordionSummary>
                    <AccordionDetails sx={{ p: 0, lineHeight: "1.5" }}>
                      {t(
                        LOCALIZATION.I_dont_know_my_Gotram_can_I_offer_ChadhavaAnswer,
                      )}
                    </AccordionDetails>
                  </Accordion>

                  <Accordion
                    className="accordionInfo"
                    expanded={expanded === "panel6"}
                    onChange={handleChange1("panel6")}
                    sx={{
                      "&.Mui-expanded::before": {
                        opacity: 1,
                      },
                    }}
                  >
                    <AccordionSummary
                      expandIcon={
                        <ExpandMoreIcon
                          sx={{
                            color: expanded === "panel6" ? "#d56939" : "#000",
                            transform:
                              expanded === "panel6"
                                ? "rotate(180deg)"
                                : "rotate(270deg)",
                            transition: "transform 0.3s ease",
                          }}
                        />
                      }
                      aria-controls="panel6-content"
                      id="panel6-header"
                      sx={{
                        p: 0,
                        fontWeight: "600",
                      }}
                    >
                      {t(LOCALIZATION.Could_I_receive_any_proof_of_my_Chadhava)}
                    </AccordionSummary>
                    <AccordionDetails sx={{ p: 0, lineHeight: "1.5" }}>
                      {t(
                        LOCALIZATION.Could_I_receive_any_proof_of_my_ChadhavaAnswer,
                      )}
                    </AccordionDetails>
                  </Accordion>

                  <Accordion
                    className="accordionInfo"
                    expanded={expanded === "panel7"}
                    onChange={handleChange1("panel7")}
                    sx={{
                      "&.Mui-expanded::before": {
                        opacity: 1,
                      },
                    }}
                  >
                    <AccordionSummary
                      expandIcon={
                        <ExpandMoreIcon
                          sx={{
                            color: expanded === "panel7" ? "#d56939" : "#000",
                            transform:
                              expanded === "panel7"
                                ? "rotate(180deg)"
                                : "rotate(270deg)",
                            transition: "transform 0.3s ease",
                          }}
                        />
                      }
                      aria-controls="panel7-content"
                      id="panel7-header"
                      sx={{
                        p: 0,
                        fontWeight: "600",
                      }}
                    >
                      {t(
                        LOCALIZATION.Who_should_I_reach_out_to_for_more_information,
                      )}
                    </AccordionSummary>
                    <AccordionDetails sx={{ p: 0, lineHeight: "1.5" }}>
                      {t(
                        LOCALIZATION.Who_should_I_reach_out_to_for_more_details_FAQ_Answer,
                      )}
                    </AccordionDetails>
                  </Accordion>

                  <Accordion
                    className="accordionInfo"
                    expanded={expanded === "panel8"}
                    onChange={handleChange1("panel8")}
                    sx={{
                      "&.Mui-expanded::before": {
                        opacity: 1,
                      },
                    }}
                  >
                    <AccordionSummary
                      expandIcon={
                        <ExpandMoreIcon
                          sx={{
                            color: expanded === "panel8" ? "#d56939" : "#000",
                            transform:
                              expanded === "panel8"
                                ? "rotate(180deg)"
                                : "rotate(270deg)",
                            transition: "transform 0.3s ease",
                          }}
                        />
                      }
                      aria-controls="panel8-content"
                      id="panel8-header"
                      sx={{
                        p: 0,
                        fontWeight: "600",
                      }}
                    >
                      {t(
                        LOCALIZATION.Can_I_choose_the_temple_and_types_of_chadhava,
                      )}
                    </AccordionSummary>
                    <AccordionDetails sx={{ p: 0, lineHeight: "1.5" }}>
                      {t(
                        LOCALIZATION.Can_I_choose_the_temple_and_types_of_chadhavaAnswer,
                      )}
                    </AccordionDetails>
                  </Accordion>
                  <Accordion
                    className="accordionInfo"
                    expanded={expanded === "panel9"}
                    onChange={handleChange1("panel9")}
                    sx={{
                      "&.Mui-expanded::before": {
                        opacity: 1,
                      },
                    }}
                  >
                    <AccordionSummary
                      expandIcon={
                        <ExpandMoreIcon
                          sx={{
                            color: expanded === "panel9" ? "#d56939" : "#000",
                            transform:
                              expanded === "panel9"
                                ? "rotate(180deg)"
                                : "rotate(270deg)",
                            transition: "transform 0.3s ease",
                          }}
                        />
                      }
                      aria-controls="panel9-content"
                      id="panel9-header"
                      sx={{
                        p: 0,
                        fontWeight: "600",
                      }}
                    >
                      {t(
                        LOCALIZATION.How_do_you_ensure_the_security_and_sanctity_of_my_offering,
                      )}
                    </AccordionSummary>
                    <AccordionDetails sx={{ p: 0, lineHeight: "1.5" }}>
                      {t(
                        LOCALIZATION.How_do_you_ensure_the_security_and_sanctity_of_my_offeringAnswer,
                      )}
                    </AccordionDetails>
                  </Accordion>
                </Box>
              </Box>

              <TrustedLogo />
              {totalPrice > 0 && isActiveTemple === true && (
                <Box
                  className="chadhavaContinueBtn desktopOnly sticky-button"
                  sx={{ position: `${isAboveFooter ? "absolute" : "fixed"}` }}
                >
                  <Stack
                    direction="row"
                    spacing={2}
                    justifyContent="space-between"
                    alignItems="center"
                  >
                    <Box
                      display="flex"
                      gap={2}
                      justifyContent="center"
                      alignItems="center"
                    >
                      <Typography>
                        {" "}
                        {`${currencySymbols}${getDisplayTotalPrice()}`}
                        /-
                      </Typography>
                      {offerActualPriceLocal > 0 && (
                        <OfferPriceTypography
                          currencySymbol={currencySymbols ?? "₹"}
                          amount={getDisplayTotalOfferPrice()}
                        />
                      )}
                    </Box>
                    {/* <CalculateOverSeasPrice  inrPrice={Number(props?.totalPrice)} priceFor="chadhava-continue"/> */}
                    <Button
                      className={
                        totalPrice === 0
                          ? "desktopContinueBtnGrey"
                          : "desktopContinueBtn"
                      }
                      onClick={() => {
                        if (
                          showSubscription &&
                          selectedChadhavaSubscriptionPlan?.subscriptionId
                        ) {
                          preprocessingAndProceedToAddmemberScreen();
                          return;
                        }
                        if (isSingleDatePujaEnabled) {
                          bookedSingleDatePuja();
                        } else {
                          handleSetIsDateTimePicker(true);
                        }
                      }}
                      disabled={totalPrice === 0}
                    >
                      {" "}
                      {t(LOCALIZATION.Continue_to_Book)}
                    </Button>
                  </Stack>
                </Box>
              )}

              <Box className="blessContinueChadhava"></Box>
              {totalPrice > 0 && isActiveTemple && (
                <Box className="blessContinue" data-scroll-id={"bless-Continue"}>
                  <Box className="viewBless">
                    <img src={viewBless} alt="viewBless"></img>
                  </Box>
                  <Box className="continueCart">
                    <Box className="continueCenterBlock">
                      <Box
                        display="flex"
                        gap={1}
                        justifyContent="center"
                        alignItems="center"
                        className="continueLt"
                      >
                        {`${currencySymbols}${getDisplayTotalPrice()}`}
                        /-
                        {offerActualPriceLocal > 0 && (
                          <OfferPriceTypography
                            currencySymbol={currencySymbols ?? "₹"}
                            amount={getDisplayTotalOfferPrice()}
                          />
                        )}
                      </Box>

                      <Box className="continueRt">
                        <Button
                          type="button"
                          disabled={totalPrice === 0}
                          className={
                            totalPrice === 0 ? "continueBtnDsbl" : "continueBtn"
                          }
                          onClick={() => {
                            if (
                              showSubscription &&
                              selectedChadhavaSubscriptionPlan?.subscriptionId
                            ) {
                              preprocessingAndProceedToAddmemberScreen();
                              return;
                            }
                            if (isSingleDatePujaEnabled) {
                              bookedSingleDatePuja();
                            } else {
                              handleSetIsDateTimePicker(true);
                            }
                          }}
                        >
                          {t(LOCALIZATION.Continue_to_Book)}
                        </Button>
                      </Box>
                    </Box>
                  </Box>
                </Box>
              )}
            </Box>
          </Grid>
          <Grid
            item
            xs={12}
            md={2}
            lg={2}
            xl={2}
            className="pagehdRightBlock"
          ></Grid>
        </Grid>
        <Dialog
          className="dateTimingSelection"
          onClose={() => setIsDateTimePicker(false)}
          open={isDateTimePicker}
        >
          <Box className="dateTimePopup">
            <Stack
              direction="row"
              justifyContent="space-between"
              alignItems="center"
              className="calendarTopInfo"
            >
              <TitleTypography
                title={t(LOCALIZATION.Select_Date)}
              ></TitleTypography>
              <IconButton
                aria-label="close"
                onClick={() => setIsDateTimePicker(false)}
                className="topCloseIconBtn"
                sx={{
                  position: "absolute",
                  right: 14,
                  top: 14,
                }}
              >
                <CloseIcon />
              </IconButton>
            </Stack>

            <Box className="calendarInfo">
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DateCalendar
                  shouldDisableDate={shouldDisableDate}
                  disablePast={true}
                  referenceDate={defaultCalendardate}
                  value={pujaDateAndTime?.pujaDate || null}
                  slots={{ day: CustomDay }}
                  slotProps={{
                    day: {
                      shouldDisableDate: shouldDisableDate,
                    } as any,
                  }}
                  onChange={(value: any) => {
                    setPujaDateAndTime({
                      ...pujaDateAndTime,
                      pujaDate: value,
                    });
                  }}
                />
              </LocalizationProvider>
            </Box>
            <Box className="btnContinue" data-scroll-id={"continue-btn"}>
              <RoundedButton
                title={t(LOCALIZATION.Continue)}
                disabled={
                  pujaDateAndTime && pujaDateAndTime?.pujaDate ? false : true
                }
                onClick={(e: any) => {
                  e.preventDefault();
                  setIsDateTimePicker(false);
                  preprocessingAndProceedToAddmemberScreen();
                  // if (cartInfo && cartInfo.length > 0) {
                  //   setPopupItemAlreadyAddedInCart(true);
                  // } else {
                  //   preprocessingAndProceedToAddmemberScreen();
                  // }
                  //
                }}
              ></RoundedButton>
            </Box>
          </Box>
        </Dialog>

        <Dialog
          // className="dateTimingSelection"
          onClose={() => setPopupItemAlreadyAddedInCart(false)}
          open={popupItemAlreadyAddedInCart}
        >
          <Box style={{ padding: "1em" }}>
            <Typography>
              {t(LOCALIZATION.A_puja_already_added_in_your_cart)}
            </Typography>
            <Box sx={{ textAlign: "end" }}>
              <Button onClick={() => setPopupItemAlreadyAddedInCart(false)}>
                {t(LOCALIZATION.No)}
              </Button>
              <Button
                onClick={() => preprocessingAndProceedToAddmemberScreen()}
              >
                {t(LOCALIZATION.Yes)}
              </Button>
            </Box>
          </Box>
        </Dialog>

        <Dialog
          onClose={() => setItemAddLimitPopUp(false)}
          open={itemAddLimitPopUp}
        >
          <Box style={{ padding: "1em" }}>
            <Typography>{t(LOCALIZATION.Cart_Max_Limit_Message)}</Typography>
            <Box sx={{ textAlign: "end" }}>
              <Button onClick={() => setItemAddLimitPopUp(false)}>
                {t(LOCALIZATION.OK)}
              </Button>
            </Box>
          </Box>
        </Dialog>
      </Box>
      <AlertDialog
        open={openAlertDialogForBookingNotAllowed}
        onClose={handleCloseAlertDialogForBookingNotAllowed}
        message={
          "Oops! Bookings are not permitted in your country. We apologize for the inconvenience. Please note that bookings are accepted only in India, Great Britain, USA, and Canada."
        }
      />
    </Box>
  );
};

export default ChadhavaDetailsView;
